module.exports = __webpack_public_path__ + "static/media/elis.413d7bc0.png";